import type { PropsWithChildren } from 'react';
import { forwardRef } from 'react';
import { Accordion as ChakraAccordion } from '@chakra-ui/react';
import type { AccordionProps as ChakraAccordionProps } from '@chakra-ui/react';

type AccordionProps = PropsWithChildren<{
    id?: string;
    onChange?: (index: number | number[]) => void;
    defaultIndex?: number | number[];
    index?: number | number[];
    variant?: ChakraAccordionProps['variant'];
    allowMultiple?: boolean;
}>;

export const Accordion = forwardRef<HTMLDivElement, AccordionProps>(
    ({ id, children, onChange, defaultIndex = -1, index, variant, allowMultiple = false }, ref) => (
        <ChakraAccordion
            ref={ref}
            onChange={onChange}
            data-testid={id}
            width="100%"
            allowToggle={!allowMultiple}
            allowMultiple={allowMultiple}
            defaultIndex={defaultIndex}
            index={index}
            variant={variant}
        >
            {children}
        </ChakraAccordion>
    ),
);

Accordion.displayName = 'Accordion';

Accordion.defaultProps = {
    id: undefined,
    onChange: undefined,
    defaultIndex: -1,
    index: undefined,
    variant: undefined,
    allowMultiple: false,
};
